import { render } from "./FormDetail.vue?vue&type=template&id=6bfd0d96&scoped=true&ts=true"
import script from "./FormDetail.vue?vue&type=script&lang=ts"
export * from "./FormDetail.vue?vue&type=script&lang=ts"

import "./FormDetail.vue?vue&type=style&index=0&id=6bfd0d96&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfd0d96"]])

export default __exports__